import type { MarbleGame } from 'src/types/domain/Game'
import { useGetCurrentBet } from 'src/hooks/useGetCurrentBet'
import { CurrentBetPanel } from './CurrentBetPanel'

type Props = Readonly<{
  game: MarbleGame
}>

export function CurrentBetPanelContainer({ game }: Props) {
  const { currentBet } = useGetCurrentBet()

  return <CurrentBetPanel bet={currentBet} game={game} />
}
